<template>
  <VuePerfectScrollbar
    class="bbp-reminder-panel-body"
    :style="{height: `calc(100vh - ${isShowForm ? '539' : '136'}px)`}"
  >
    <div
      v-for="item in reminders"
      :key="item._id"
      class="bbp-reminder-panel-body-item"
    >
      <i
        class="bbp-icon-menu bbp-reminder-panel-body-item__menu"
        @click="isShowMenuPopup(item, $event)"
      />
      <div
        :class="[
          'bbp-reminder-panel-body-item__pointer',
          isRead(item) && 'bbp-reminder-panel-body-item__pointer_read'
        ]"
        @click="onRead(item)"
      />
      <div class="bbp-reminder-panel-body-item__image">
        <img :src="getUserImage(item)" alt="">
      </div>
      <div class="bbp-reminder-panel-body-item__wrap">
       <div class="bbp-reminder-panel-body-item__title">
         {{ getUserName(item) }}
       </div>
       <div class="bbp-reminder-panel-body-item__description">
         {{ item.comment }}
       </div>
       <BBPReminderPanelBodyUsers :users="item.targetUser"/>
        <div class="bbp-reminder-panel-body-item__date">
          {{ getDate(item) }}
        </div>
      </div>
    </div>
    <transition name="bbp-bounce">
      <BBPPopupButtons
        v-if="isShowPopupButton"
        :popupPosition="popupStyle"
        :isShowPopupButton.sync="isShowPopupButton"
        @onButtonTop="onEditReminder"
        @onButtonBottom="onDeleteReminder"
      />
    </transition>
  </VuePerfectScrollbar>
</template>

<script>
import {get} from 'lodash'
import moment from 'moment'
import avatarUserDefault from '@/assets/images/avatar-user-default.png'
import BBPReminderPanelBodyUsers from
  '@/components/Main/BBPTable/BBPReminder/BBPReminderPanel/BBPReminderPanelBody/BBPReminderPanelBodyUsers'
import BBPPopupButtons from '@/components/Main/BBPPopups/BBPPopupButtons'
import ReminderApi from '@/api/Reminders/api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: 'BBPReminderPanelBody',
  components: {
    BBPReminderPanelBodyUsers,
    BBPPopupButtons,
    VuePerfectScrollbar
  },
  props: {
    isShowForm: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isShowPopupButton: false,
    popupStyle: {},
    currentElement: {}
  }),
  computed: {
    reminders: {
      get () {
        return this.$store.getters.reminders
      },
      set (data) {
        this.$store.dispatch('setReminders', data)
      }
    },
    userInfo () {
      return this.$store.getters.userInfo || {}
    }
  },
  methods: {
    isRead ({ readUsers = [] }) {
      const { id = '5f8097e4e06d0800124c7a5d' } = this.userInfo
      const item = readUsers.find((el) => el === id)
      return item
    },
    getUserImage ({ user = [] }) {
      const [item = {}] = user
      return get(item, 'image.path', avatarUserDefault)
    },
    getUserName ({ user = [] }) {
      const [item = {}] = user
      return get(item, 'username', '')
    },
    getDate ({ nextReminder }) {
      const date = moment(nextReminder)
      const reminderToday = moment(nextReminder).format('DD-MMM-YY')
      const today = moment().format('DD-MMM-YY')
      return today === reminderToday ? date.format('hh:mm A') : date.format('DD-MMM-YY, hh:mm A')
    },
    isShowMenuPopup (item, { target }) {
      this.currentElement = item
      this.isShowPopupButton = !this.isShowPopupButton
      const { top, height } = target.getBoundingClientRect()
      this.popupStyle = {
        position: 'fixed',
        top: `${top + height + 2}px`,
        right: '22px',
        cursor: 'pointer'
      }
    },
    onEditReminder  () {
      this.$emit('onOpenForm', this.currentElement)
    },
    async onDeleteReminder  () {
      const { _id } = this.currentElement
      const index = this.reminders.findIndex((el) => el._id === _id)
      this.reminders.splice(index, 1)
      this.isShowPopupButton = false
      try {
        await ReminderApi.deleteReminder(_id)
      } catch (err) {
        console.error(err)
      }
    },
    async onRead ({_id}) {
      try {
        const { data } = await ReminderApi.onReadReminder(_id)
        const { readUsers = [] } = data
        const item = this.reminders.find((el) => el._id === _id)
        item.readUsers = readUsers
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../sass/variables";

  .bbp-reminder-panel-body {
    padding: 0 25px 0 25px;
    height: calc(100vh - 136px);
    margin-bottom: 55px;
  }

  .bbp-reminder-panel-body-item {
    display: grid;
    grid-template-columns: 28px 1fr;
    grid-gap: 0 13px;
    padding: 20px 0 22px 0;
    border-bottom: 1px solid $color-wild-sand;
    position: relative;

    &:hover .bbp-reminder-panel-body-item__menu {
      opacity: 1;
    }

    &:hover .bbp-reminder-panel-body-item__pointer {
      opacity: 1;
    }

    &__menu {
      opacity: 0;
      position: absolute;
      transform: rotate(90deg);
      color: $color-silver;
      right: -3px;
      top: 23px;
      font-size: 15px;
      cursor: pointer;
      transition: 0.25s;

      &:hover {
        opacity: 0.9;
      }
    }

    &__pointer {
      opacity: 0;
      position: absolute;
      top: 24px;
      left: -20px;
      width: 6px;
      height: 6px;
      border: 7px solid $color-white;
      border-radius: 50%;
      background: $color-denim;
      box-sizing: content-box;
      cursor: pointer;
      transition: 0.25s;

      &_read {
        background: $color-silver;
      }

      &:hover {
        opacity: 0.9;
      }
    }

    &__wrap {
      display: grid;
      grid-gap: 7px 0;
    }

    &__image {
      width: 28px;
      height: 28px;
      overflow: hidden;
      border-radius: 50%;

      img {
        width: 100%;
        height: 100%;
      }
    }

    &__title {
      font-size: 14px;
      line-height: 17px;
      color: $color-black;
      font-weight: 500;
      text-transform: capitalize;
    }

    &__description {
      font-size: 12px;
      line-height: 16px;
      font-weight: 400;
    }

    &__date {
      font-size: 12px;
      line-height: 14px;
      font-weight: 400;
      color: $color-gray;
    }
  }
</style>

<style lang="scss">

  .bbp-reminder-panel-body {

    .bbp-popup-buttons:before {
      left: 77px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPReminder/BBPReminderPanel/BBPReminderPanelBody/BBPReminderPanelBody.vue